import { ValidationEntrySeverity } from '../../../../../react-commons/components/ValidationEntrySeverity';
import { onUnauthorizedWithoutHook, parseRawData } from '../../resource-base/adapters/AdapterUtils';
import { post, upload } from '../../resource-base/APIVersion1';
import {
    ImportValidationResource,
    ImportValidationResourceSchema,
} from '../../resources/validation/importValidationResource';
import { AxiosProgressEvent } from 'axios';

export class ImporterService {
    actions() {
        return ImporterServiceActions();
    }
}

function ImporterServiceActions() {
    const uploadFiles = (
        files: string[],
        errorLevel: ValidationEntrySeverity,
    ): Promise<ImportValidationResource | null> => {

        const body = {
            files,
            errorLevel,
        };

        return post('importer/import-from-file', JSON.stringify(body)).then(
            result => {
                if (result.status === 201 || result.status === 400) {
                    return result.json().then(rawData => parseRawData(rawData, ImportValidationResourceSchema));
                } else if (result.status === 401) {
                    return onUnauthorizedWithoutHook(result, null);
                }
                return Promise.reject('Could not upload the file!');
            },
            _ => Promise.reject('Could not upload the file!'),
        );
    };

    const uploadOnlineFiles = (
        files: FileList,
        name: string,
        errorLevel: ValidationEntrySeverity,
        onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
    ): Promise<boolean | null> => {
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            const file = files.item(i);
            if (file) {
                formData.append('files', file);
            }
        }
        formData.set(
            'json',
            JSON.stringify({
                name,
                errorLevel,
            }),
        );

        return upload('importer/import-from-file-online', formData, onUploadProgress).then(
            result => {
                // TODO - same logic in both branches?
                if (result.status === 201 || result.status === 400) {
                    return true;
                } else if (result.status === 200) {
                    return true;
                }
                return Promise.reject('Could not upload the file!');
            },
            _ => Promise.reject('Could not upload the file!'),
        );
    };

    return {
        uploadOnlineFiles,
        uploadFiles,
    };
}
